export default {
  methods: {
    camelize(str) {
      if (!str) return '';
      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/stringFormat.js